import { useSetObjectValue } from "../../../hooks/useSetObjectValue";
import { OperationState } from "../OperationState";
import OperationModeSelect2Step from "./OperationModeSelect2Step";
import { IAggregate } from "./types";

interface SStatefulOperationMode2StepsSelectProps extends IAggregate
{
    isCompact: boolean
}
const StatefulOperationMode2StepsSelect = (props: SStatefulOperationMode2StepsSelectProps) => {
    
    const [state, setState] = useSetObjectValue(props.id, props.resourceGroupId,"state", props.state,0);
    const onValueChangedStep1 = (e: any) => { setState(OperationState.On); }
    const onValueChangedStep2 = (e: any) => { setState(OperationState.Step2); }
    const onValueChangedOff = (e: any) => { setState(OperationState.Off); }
    const onValueChangedAuto = (e: any) => { setState(OperationState.Auto); }

    if ( props.isWriteable)
        return <OperationModeSelect2Step setStep1={onValueChangedStep1} setStep2={onValueChangedStep2} setAuto={onValueChangedAuto} setOff={onValueChangedOff} isState={state} isCompact={props.isCompact}></OperationModeSelect2Step>
    
    return <></>
}

export default StatefulOperationMode2StepsSelect;